// Do NOT add "use client" to this file

// TODO (RSC Product Tile): This function exists in web, but it is in a client-only file.
// Remove this file once the function is moved out of the client-only file in web.

/**
 * This should NOT be used in new code.
 *
 * This was used to migrate from localize -> strictLocalize and LocalMsg -> StrictLocalMsg to force values objects to align and should not be used anymore
 * */
export const DEPRECATED_backwardsCompatibleValues = <T>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: Record<string, any>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): T => values as any;
